var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManagerCodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.01754L16.2254 2.0117H1.77465L9 7.01754ZM16.2254 13.9883V4.02339L9 8.98246L1.77465 4.02339V13.9883H16.2254ZM16.2254 0C16.7042 0 17.1127 0.202729 17.4507 0.608187C17.8169 1.01365 18 1.48148 18 2.0117V13.9883C18 14.5185 17.8169 14.9864 17.4507 15.3918C17.1127 15.7973 16.7042 16 16.2254 16H1.77465C1.29577 16 0.873239 15.7973 0.507042 15.3918C0.169014 14.9864 0 14.5185 0 13.9883V2.0117C0 1.48148 0.169014 1.01365 0.507042 0.608187C0.873239 0.202729 1.29577 0 1.77465 0H16.2254Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagerCodes);
export default __webpack_public_path__ + "static/media/icon-manager-codes.52031019d2f8f6273d1ba08f52681767.svg";
export { ForwardRef as ReactComponent };